import { render } from "./StickyBranchName.vue?vue&type=template&id=62eabe2d"
import script from "./StickyBranchName.vue?vue&type=script&lang=js"
export * from "./StickyBranchName.vue?vue&type=script&lang=js"

import "./StickyBranchName.vue?vue&type=style&index=0&id=62eabe2d&lang=scss"
script.render = render

export default script